module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mdc-layout-grid__inner"
  }, [_c('div', {
    staticClass: "mdc-layout-grid__cell\n              mdc-layout-grid__cell--span-4"
  }), _vm._v(" "), _c('div', {
    staticClass: "mdc-layout-grid__cell\n              mdc-layout-grid__cell--span-4"
  }, [_c('div', {
    staticClass: "mdc-card"
  }, [_c('section', {
    staticClass: "mdc-card__media",
    attrs: {
      "id": "portrait"
    }
  }, [_c('span', {
    staticClass: "mdc-toolbar__icon circular--portrait"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/Profile_pic_square_mid.png")
    }
  })])]), _vm._v(" "), _c('section', {
    staticClass: "mdc-card__primary"
  }, [_c('h1', {
    staticClass: "mdc-card__title mdc-card__title--large"
  }, [_vm._v("Ajay Addepalle")])]), _vm._v(" "), _c('section', {
    staticClass: "mdc-card__supporting-text"
  }, [_c('h2', {
    staticClass: "mdc-card__subtitle"
  }, [_vm._v("Software Engineer")])]), _vm._v(" "), _c('section', {
    staticClass: "mdc-card__actions"
  }, [_c('a', {
    staticClass: "mdc-button mdc-button__icon mdc-button--accent",
    attrs: {
      "href": "mailto:ajay.addepalle@gmail.com",
      "title": "Email me @ ajay.addepalle@gmail.com"
    }
  }, [_c('i', {
    staticClass: "material-icons",
    staticStyle: {
      "vertical-align": "middle"
    }
  }, [_vm._v("email")]), _vm._v(" Email\n        ")]), _vm._v(" "), _c('a', {
    staticClass: "mdc-button mdc-button__icon mdc-button--accent",
    attrs: {
      "href": "https://github.com/ajay-addepalle",
      "title": "See my open source project work @ https://github.com/aakoss"
    }
  }, [_c('i', {
    staticClass: "material-icons",
    staticStyle: {
      "vertical-align": "middle"
    }
  }, [_vm._v("code")]), _vm._v(" Github\n        ")])])]), _vm._v(" "), _c('div', {
    staticClass: "mdc-layout-grid__cell\n                mdc-layout-grid__cell--span-4"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-bfe2109e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Contact.vue
// module id = 71
// module chunks = 1